// extracted by mini-css-extract-plugin
export var error = "Question_error__4JlTU";
export var limitPhrases = "Question_limitPhrases__ggudO";
export var md = "768px";
export var phrase = "Question_phrase__SDYmM";
export var questionContainer = "Question_questionContainer__RyPVJ";
export var questionLabel = "Question_questionLabel__W1Top";
export var questionLabelContainer = "Question_questionLabelContainer__XfYjn";
export var questionSubLabel = "Question_questionSubLabel__PVTe4";
export var radioColorQuestion = "Question_radioColorQuestion__028Hg";
export var shake = "Question_shake__C69s+";
export var shared = "\"../../../shared.module.css\"";